<template>
  <v-data-table 
    :headers="headers"
    :items="list" 
    :loading="loading"
    hide-default-footer
    :items-per-page="-1"
  >
    <template v-slot:item.receipt="{ item }">
      <a v-if="item.receipt" :href="item.receipt" download="recall_receipt.pdf">Receipt</a>
    </template>
    <template v-slot:item.action="{ item }">
      <v-btn icon text @click="deleteItem(item)" color="red">
        <v-icon small>delete</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>
<script>

export default {
  name: "RecallSales",
  props: {
    saleId: {
      default: null
    }
  },
  data: () => ({
    headers: [
      {
        text: '#',
        align: 'left',
        sortable: false,
        value: 'id',
      },
      { text: 'Date', value: 'date' },
      { text: 'Notes', value: 'notes' },
      { text: 'Receipt', value: 'receipt' },
      { text: 'Actions', value: 'action', sortable: false },
    ],
    list: [],
    loading: false
  }),
  methods: {
    async getRecalls() {
      if(!this.saleId) {
        this.$toast.error('Sale id missing');
        return;
      }
      this.loading = true;
      try {
        const { data } = await this.$recallService.getRecalls(this.saleId);
        this.list = data;
      } catch (error) {
        this.$errorResponse(error);
      }
      this.loading = false;
    },
    async deleteItem(item) {
      this.loading = true;
      try {
        await this.$recallService.deleteRecall(item.id);
        this.getRecalls();
      } catch (error) {
        this.$errorResponse(error);
      }
      this.loading = false;
    }

  },
  mounted() {
    this.getRecalls();
  }
};
</script>